import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
export function PricingSection() {
  return <section className="py-10 md:py-24 bg-charcoal relative" data-id="element-255">
      <div className="max-w-xl mx-auto px-6 text-center" data-id="element-256">
        <FadeIn data-id="element-257">
          <div className="bg-charcoal-dark border border-sand/30 rounded-sm p-8 md:p-12 shadow-[0_0_60px_rgba(212,165,116,0.06)]" data-id="element-258">
            <p className="text-sm font-medium uppercase tracking-[0.2em] text-sand/70 mb-6" data-id="element-259">
              Precio de Fundador
            </p>

            <div className="flex items-center justify-center gap-4 mb-4" data-id="element-260">
              <span className="text-2xl md:text-3xl text-offwhite-dim/40 line-through font-heading font-bold" data-id="element-261">
                $97
              </span>
              <span className="text-5xl md:text-6xl font-heading font-bold text-sand" data-id="element-262">
                $47
              </span>
            </div>

            <p className="text-amber font-medium text-lg mb-8" data-id="element-263">
              Solo 10 cupos.
            </p>

            <Button href="https://wa.link/we351n" size="lg" withArrow className="w-full shadow-2xl shadow-sand/20" data-id="element-264">
              Escribí RESET → $47 esta semana (quedan 5 cupos)
            </Button>
          </div>
        </FadeIn>
      </div>
    </section>;
}